module.exports = __webpack_public_path__ + "img/login.c620bd3e.png";